import {Lobby, LobbyUser, ReadyStatus} from "../../app/types/lobby";
import {Game} from "../../app/types/game";

export enum AckCode {
    OK = 'OK',
    SYNC_NEEDED = 'SYNC_NEEDED',
    GENERIC_ERROR = 'GENERIC_ERROR',
    ILLEGAL_MOVE = 'ILLEGAL_MOVE'
}

export type LobbyEvent =
    | { type: 'LOBBY_STATE'; version: number; lobby: Lobby }
    | { type: 'PLAYER_JOINED'; version: number; player: LobbyUser }
    | { type: 'PLAYER_LEFT'; version: number; playerId: number }
    | { type: 'PLAYER_READY'; version: number; playerId: number, ready: ReadyStatus }
    | { type: 'GAME_STARTED'; version: number; gameId: string }
    | { type: 'PLAYER_HANG'; version: number; playerId: number; timeoutSec: number }
    | { type: 'PLAYER_BACK'; version: number; playerId: number };

export type GameEvent =
    | { type: 'GAME_STATE'; version: number; game: Game }
    | { type: 'PLAYER_LEFT'; version: number; playerId: number }
    | { type: 'PLAYER_HANG'; version: number; playerId: number; timeoutSec: number }
    | { type: 'PLAYER_BACK'; version: number; playerId: number };

export type AckEvent =
    | { type: 'OK'; requestId: string }
    | { type: 'ERROR'; requestId?: string; code: AckCode; message: string }
    | { type: string; [k: string]: any };
